import TopImage from "@components/shared/contactUsIcons/topImage";
import React, { ReactElement } from "react";
import styles from "./contactTop.module.scss";
import { useDomainContext } from "@hooks/useDomainContext";

export default function ContactTop({
    iconsFillColor,
}: {
    iconsFillColor?: string;
}): ReactElement {
    const { domain, domainNameTranslation } = useDomainContext();

    return (
        <div className="flex justify-between flex-col md:flex-row items-center h-96 md:h-72 relative px-4 z-10">
            <div>
                <h1 className="text-3xl font-extrabold">
                    {domain?.translations?.[
                        `${domainNameTranslation}_contactUsMainLabel`
                    ] ?? `Contact Us`}
                </h1>
                <p className="text-xl w-11/12">
                    {domain?.translations?.[
                        `${domainNameTranslation}_contactUsSubLabel`
                    ] ?? `We are open to discuss potential opportunities.`}
                </p>
            </div>
            <span className={` ${styles.img}`}>
                <TopImage fill={iconsFillColor} />
            </span>
        </div>
    );
}
